import { render, staticRenderFns } from "./TimeKPIChart.vue?vue&type=template&id=615fa85a&"
import script from "./TimeKPIChart.vue?vue&type=script&lang=js&"
export * from "./TimeKPIChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports